import React, { Component } from 'react';

export default class Benefits extends Component {
  render() {
    return (
      <p>Benefits</p>
    );
  }
}
